import { render, staticRenderFns } from "./Proofing.vue?vue&type=template&id=a0d2ead4&scoped=true&"
import script from "./Proofing.vue?vue&type=script&lang=js&"
export * from "./Proofing.vue?vue&type=script&lang=js&"
import style0 from "./Proofing.vue?vue&type=style&index=0&id=a0d2ead4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d2ead4",
  null
  
)

export default component.exports